import React from "react";
import { useSelector } from "react-redux";
import PayRollTable from "../../../../components/Tables/PayRollTable";
import { Loader } from "../../../../components/Loader/Loader";
import { useTheme } from "../../../../Themecontext/Themecontext";

const Increment = ({ employeeName }) => {
  const { Colourdata } = useSelector((state) => state.ClientLogin);
  const { EmployeeIncrementdata } = useSelector((s) => s.PayRollSlice);
  console.log(EmployeeIncrementdata);

  const iscolour = Colourdata?.data?.find((el) => el.ExeName === "NEWPAYROLL");
  const iscolourDark = Colourdata?.data?.find(
    (el) => el.ExeName === "NEWPAYROLLDARK",
  );

  const { theme } = useTheme();
  const isdark = theme;

  const months = [
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
    "Jan",
    "Feb",
    "Mar",
  ];

  const getRows = EmployeeIncrementdata?.Data?.map((item, i) => ({
    id: i + 1,
    DepartmentName: item.DepartmentName,
    employee: item.employee,
    AcYearR: item.AcYearR,
    Total: item.TotalIncrement,
    ...months.reduce((acc, m) => ({ ...acc, [m]: item[`${m}Inc`] }), {}),
  }));

  const getColumns = [
    { key: "srNumber", label: "SrNumber", align: "center" },
    { key: "AcYearR", label: "AcYear", align: "center" },
    { key: "Total", label: "Total Increment", align: "right", format: "true" },
    {
      key: "DepartmentName",
      label: "Department",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },

    ...months.map((m) => ({
      key: m,
      label: m,
      format: true,
    })),
  ];
  if (!employeeName || employeeName.length === 0) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "70vh",
          fontSize: "18px",
          color:
            isdark === "light" ? iscolour?.Colour11 : iscolourDark?.Colour10,
        }}
      >
        Please Select Employee Name
      </div>
    );
  }

  if (EmployeeIncrementdata === "no" || EmployeeIncrementdata === null) {
    return (
      <div
        style={{
          height: "70vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Loader />
      </div>
    );
  }
  return (
    <div
      style={{
        marginTop: "25px",
        borderRadius: "12px",
        overflow: "hidden",
        boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
      }}
    >
      <div
        style={{
          padding: "14px",
          background:
            isdark === "light" ? iscolour?.Colour6 : iscolourDark?.Colour7,
          color: "#fff",
          fontWeight: "600",
          fontSize: "18px",
          margin: 0,
          letterSpacing: "1px",
        }}
      >
        EMPLOYEE INCREMENT
      </div>

      <PayRollTable columns={getColumns} data={getRows} />
    </div>
  );
};

export default Increment;
